<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<el-switch v-model="unupload" @change="unuploadChange" active-text="显示未上传" inactive-text=""></el-switch>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent" ref="invoicewriteoff_list"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
		<uploadinvoice :row="currentrow" ref="uploadinvoice" @modalhide="uploadinvoiceHide" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import uploadinvoice from './uploadinvoice/index.vue'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				unupload:false,
				modal_title: '发票核销',
				modal_width: 1200,
				modal_height: 800,
				list_footerField: [{
					field: 'needamount',
					toFixed: 2
				}],
				foreingKey: {
					hasinvoice: 5
				},
				currentrow: null,
				list_formConfig: [{
					field: 'accName',
					title: '付款公司',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'bankAcc',
					title: '付款账号',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'rcvName',
					title: '收款公司/人',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'rcvAcc',
					title: '收款账号',
					itemRender: {
						name: '$input'
					}
				}],
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = [{
						field: 'accName',
						title: '付款公司'
					},
					{
						field: 'bankAcc',
						title: '付款账号'
					},
					{
						field: 'rcvName',
						title: '收款公司/人'
					},
					{
						field: 'rcvAcc',
						title: '收款账号'
					},
					{
						field: 'purchasesum',
						title: '金额',
					},
					{
						field: 'invoicefile',
						title: '发票',
						slots:{
							default:({row})=>{
								return 	row.invoicefile? <el-image style="width: 30px; height: 30px" src={row.invoicefile[0].path} preview-src-list={row.invoicefile.map((item)=>{
									return item.path
								})}></el-image> : ''
							}
						}
					},
					{
						field: '',
						title: '操作',
						width: 100,
						fixed: "right",
						align: 'center',
						cellRender: {
							bind: this,
							name: '$operateButton',
							buttons: [{
								code: 'uploadinvoice',
								content: '上传发票',
								status: 'danger',
								inrow: true
							}]
						}
					}
				]
				gridOptions.pagerConfig = {
					enabled: true,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500],
				}
				//gridOptions.formConfig = false
			},
			operateButtonClickEvent(e) {
				if (this[e.code]) {
					this[e.code](e.data)
				}
			},
			list(page, updateForm, other) {
				return new Promise(resolve => {
					this.$api.paymentapplication.list({
						...page,
						...updateForm,
						...other,
						...this.foreingKey
					}).then((res) => {
						resolve(res)
					}, () => {
						resolve()
					})
				})
			},
			uploadinvoice(row) {
				this.currentrow = row
				this.$refs.uploadinvoice.modal_show()
			},
			uploadinvoiceHide() {
				this.$refs.invoicewriteoff_list.commitProxy('query')
			},
			unuploadChange(e){
				this.$refs.invoicewriteoff_list.commitProxy('query',{isupload:e?1:0})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			},

		},
		components: {
			uploadinvoice
		}
	}
</script>